// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1vZlN","buttons":"Footer_buttons__1Aumk"};